import { InjectionKey } from 'vue';
import { Unsubscribe } from '@/common/domain/Unsubscribe';
import { Clicked } from '@/common/domain/click/Clicked';

export const clickBusKey: InjectionKey<ClickBus> = Symbol();

export interface ClickBus {
  onClick(clicked: Clicked): Unsubscribe;
}
